import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import StatsOverview from "@/pages/home/components/StatsOverview";
import WorkRanking from "@/pages/home/components/WorkRanking";
import RatingBreakdown from "@/pages/home/components/RatingBreakdown";
import FeaturedReviews from "@/pages/home/components/FeaturedReviews";
import AudienceWall from "@/pages/home/components/AudienceWall";
import SelectionGuide from "@/pages/home/components/SelectionGuide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <StatsOverview />
        <WorkRanking />
        <RatingBreakdown />
        <FeaturedReviews />
        <AudienceWall />
        <SelectionGuide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}